import { useEffect, useState } from "react";
import { ArrowRight, Lock, MailCheck, Rocket, Sparkles } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { postJson } from "../lib/api";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const { loginWithOtp } = useAuth();

  const requestLink = async () => {
    setBusy(true);
    setError("");
    try {
      await postJson("/api/auth/request-magic-link", { email });
      setSent(true);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : String(caught));
    } finally {
      setBusy(false);
    }
  };

  const submitOtp = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await loginWithOtp(otp);
      window.location.assign("/");
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : String(caught));
    } finally {
      setBusy(false);
    }
  };

  return <section className="login-page">
    <div className="login-page__art" aria-hidden="true" />
    <div className="login-page__shade" aria-hidden="true" />
    <div className="login-page__welcome">
      <div className="login-brand"><span className="login-brand__mark"><Sparkles /></span><span>BrainPower</span></div>
      <div className="login-welcome-copy">
        <p className="login-kicker">IMPARA. PROVA. SUPERA I TUOI LIMITI.</p>
        <h1>Qui iniziano<br />le idee grandi</h1>
        <p>Un posto tutto tuo per allenare la mente, scoprire nuove passioni e vedere quanto lontano puoi arrivare.</p>
      </div>
      <div className="login-subjects" aria-label="Materie disponibili"><span>Matematica</span><span>Scienze</span><span>Lingue</span><span>Creatività</span></div>
    </div>
    <div className="login-page__panel">
      <div className="login-card">
        <div className="login-card__icon">{sent ? <MailCheck /> : <Rocket />}</div>
        {!sent ? <form onSubmit={(event) => { event.preventDefault(); void requestLink(); }}>
          <p className="login-card__eyebrow">BENTORNATO</p>
          <h2>Accendi la tua mente</h2>
          <p className="login-card__intro">Inserisci la tua email. Riceverai un link e un codice sicuro per entrare, senza password.</p>
          <label className="login-field"><span>La tua email</span><input id="login-email" name="email" autoComplete="email" type="email" required disabled={busy} value={email} onChange={(event) => setEmail(event.target.value)} /></label>
          {error && <div className="login-alert">{error}</div>}
          <button className="login-submit" disabled={busy}>{busy ? "Prepariamo il tuo accesso..." : "Entra in BrainPower"}<ArrowRight /></button>
          <p className="login-card__note"><Lock />Il link e il codice possono essere usati solo da te.</p>
        </form> : <form onSubmit={submitOtp}>
          <p className="login-card__eyebrow">EMAIL INVIATA</p>
          <h2>Ci sei quasi</h2>
          <p className="login-card__intro">Apri il link ricevuto oppure inserisci qui il codice a 6 cifre.</p>
          <label className="login-field"><span>Codice di accesso</span><input id="login-otp" name="otp" autoComplete="one-time-code" inputMode="numeric" pattern="[0-9]{6}" maxLength={6} required disabled={busy} value={otp} onChange={(event) => setOtp(event.target.value.replace(/\D/g, ""))} /></label>
          <small className="login-helper">Il codice si trova nell'email che hai ricevuto</small>
          {error && <div className="login-alert">{error}</div>}
          <button className="login-submit" disabled={busy || otp.length !== 6}>{busy ? "Verifica in corso..." : "Accedi con il codice"}<ArrowRight /></button>
          <button type="button" className="login-resend" disabled={busy} onClick={() => void requestLink()}>Non hai ricevuto l'email? Reinvia</button>
        </form>}
      </div>
    </div>
  </section>;
}

export function MagicLinkPage() {
  const { pathname } = useLocation();
  const token = pathname.slice("/auth/magic-link/".length);
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  useEffect(() => {
    if (!token) {
      setError("Link non valido o incompleto.");
      return;
    }
    loginWithToken(token).then(() => navigate("/", { replace: true })).catch((caught) => setError(caught instanceof Error ? caught.message : String(caught)));
  }, [token, loginWithToken, navigate]);
  return <section className="login-page magic-login-page"><div className="login-page__art" /><div className="login-page__shade" /><div className="login-page__panel"><div className="login-card"><div className="login-card__icon"><MailCheck /></div><p className="login-card__eyebrow">ACCESSO SICURO</p><h2>{error ? "Link non valido" : "Accesso in corso"}</h2><p className="login-card__intro">{error || "Stiamo verificando il link ricevuto."}</p>{error && <a className="login-submit" href="/">Richiedi un nuovo link</a>}</div></div></section>;
}
